import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TemplateEditor = ({ template, onChange }) => {

  return (

    <div className="space-y-4">

      <div>

        <label className="block text-sm font-medium mb-1">
          Subject
        </label>

        <input
          value={template.subject || ""}
          onChange={(e) =>
            onChange("subject", e.target.value)
          }
          className="border rounded-lg px-3 py-2 w-full"
        />

      </div>

      <div>

        <label className="block text-sm font-medium mb-1">
          Email Content
        </label>

        <ReactQuill
          theme="snow"
          value={template.html_content}
          onChange={(value) => onChange("html_content", value)}
          className="mt-2"
        />

        <p className="text-xs text-gray-500 mt-1">
          Available placeholders: {"{{CALLS_LIST}}, {{PRIMARY_BUTTON}}, {{OPTIONS_BUTTON}}, {{ORG_NAME}}, {{ARTIST_NAME}}"}
        </p>

      </div>

    </div>

  );

};

export default TemplateEditor;